<template>
  <div>
    <model-selector :trans="trans"/>

    <choose-build-title :trans="trans"/>

<!--    <choose-moto-style/>-->

    <choose-build-color :trans="trans"/>

    <choose-build-size :trans="trans"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ModelSelector from "./ModelSelector";
import BuildTitleSelector from "./BuildTitleSelector";
import BuildColorSelector from "./BuildColorSelector";
import BuildSizeSelector from "./BuildSizeSelector";
import ExtraOptions from "./ExtraOptions";
import BuildPaymentOptionSelector from "./BuildPaymentOptionSelector";
// import MotoStyleComponent from "./MotoStyleComponent";

export default {
  name: "Selector",
  props: ['trans'],
  components: {
    'model-selector': ModelSelector,
    'choose-build-title': BuildTitleSelector,
    // 'choose-moto-style': MotoStyleComponent,
    'choose-build-color': BuildColorSelector,
    'choose-build-size': BuildSizeSelector,
    'choose-extra-options': ExtraOptions,
    'choose-payment-option': BuildPaymentOptionSelector,
  },
  computed: {
    ...mapGetters({
      'models': 'build/modelsForChoose',
      'steps': 'build/stepList',
      'extra': 'build/extraList',
      preselected: 'build/preselected',
    })
  },
  mounted() {
    this.$root.$on('scrollTo', (data) => {
      setTimeout(() => {
        this.scrollToStep(data.from, data.to)
      }, 10)
    })
  },
  methods: {
    scrollToStep(from, to) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };


      let toElement = document.getElementById(this.stepTitle(to));
      if (!toElement) {
        return
      }
      let fromElement = document.getElementById(this.stepTitle(from));
      let top = toElement.offsetTop - fromElement.getBoundingClientRect().height - 20;

      let start = window.pageYOffset || document.documentElement.scrollTop
      let change = top - start
      let currentTime = 0
      let increment = 20
      let duration = 700

      let animateScroll = function () {
        currentTime += increment;
        document.documentElement.scrollTop = document.body.scrollTop = Math.easeInOutQuad(
          currentTime, start, change, duration
        )
        if (currentTime < duration) {
          setTimeout(animateScroll, increment)
        }
      };
      animateScroll()
    },
    stepTitle(number) {
      return `step-${number}`
    }
  }
}
</script>
